import { useState, useEffect } from "react";
import { Eye } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { useRestaurantContext } from "@/contexts/RestaurantContext";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export function PeriodTotalsVisibilityCard() {
  const { activeRestaurant, refetch } = useRestaurantContext();
  const [showTotals, setShowTotals] = useState(true);

  useEffect(() => {
    if (activeRestaurant) {
      setShowTotals((activeRestaurant as any)?.show_period_totals_on_close ?? true);
    }
  }, [activeRestaurant]);

  const handleToggle = async (enabled: boolean) => {
    if (!activeRestaurant) return;
    setShowTotals(enabled);

    const { error } = await supabase
      .from("restaurants")
      .update({ show_period_totals_on_close: enabled } as any)
      .eq("id", activeRestaurant.id);

    if (error) {
      toast.error("Erro ao salvar configuração");
      setShowTotals(!enabled);
      return;
    }

    toast.success(enabled ? "Faturamento visível no fechamento" : "Faturamento ocultado no fechamento");
    await refetch();
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <Eye className="h-5 w-5" />
          Faturamento no Fechamento de Período
        </CardTitle>
        <CardDescription>
          Controla se o faturamento (total de vendas e pedidos) aparece na tela de fechamento do período
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between rounded-lg border p-4">
          <div>
            <Label className="text-base">Mostrar faturamento ao fechar período</Label>
            <p className="text-sm text-muted-foreground">
              Quando desativado, o operador não verá os totais financeiros na confirmação de fechamento
            </p>
          </div>
          <Switch checked={showTotals} onCheckedChange={handleToggle} />
        </div>
      </CardContent>
    </Card>
  );
}
